import type { Component } from '@wix/thunderbolt-symbols'

// builder components carry their real type in builderType while componentType is the literal 'Builder'
// (see fixBuilderComponent in thunderbolt-becky-root). BI reports the real type.
export const getBiCompType = (comp: Component): string => comp.builderType || comp.componentType
